/** The agent's install command for a grant; plain HTTP is accepted only when the server itself uses it (local testing). */
export function installCommand(server: string, token: string) {
  return `.\\wittco-agent.exe install --server ${server} --token ${token}${server.startsWith('http:') ? ' --allow-http' : ''}`;
}
